function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBusinessHotelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10h2V7H7v3zM12 10h2V7h-2v3zM17 10h2V7h-2v3zM7 15h2v-3H7v3zM12 15h2v-3h-2v3zM7 20h2v-3H7v3zM17.119 17.637h2c0-.84.844-1.521 1.88-1.521 1.039 0 1.883.681 1.883 1.52h2c0-1.94-1.742-3.52-3.882-3.52s-3.881 1.58-3.881 3.52zM26 28h2v-7.363h-2V28zm-12-.001h2v-7.363h-2v7.363zM18 28h6v-7.363h-6V28zm11-9.364H13a1 1 0 00-1 1V29a1 1 0 001 1h16a1 1 0 001-1v-9.364a1 1 0 00-1-1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2h18c1.1 0 2 .9 2 2v8h-2V4H4v24h4v2H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2z",
    fill: props.color
  }));
}

export default SvgIconBusinessHotelFilled;